/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as WelcomeImport } from './routes/welcome'
import { Route as JournalImport } from './routes/journal'
import { Route as AppImport } from './routes/_app'
import { Route as AppIndexImport } from './routes/_app/index'
import { Route as AppValidateImport } from './routes/_app/validate'
import { Route as AppOnboardImport } from './routes/_app/onboard'
import { Route as AppMuralImport } from './routes/_app/mural'
import { Route as AppMellinaiImport } from './routes/_app/mellinai'
import { Route as AppJourneyImport } from './routes/_app/journey'
import { Route as AppFeedbackImport } from './routes/_app/feedback'
import { Route as AppConquistasImport } from './routes/_app/conquistas'
import { Route as AppCentralImport } from './routes/_app/central'
import { Route as AppCalendarImport } from './routes/_app/calendar'
import { Route as AppProductsIndexImport } from './routes/_app/products/index'
import { Route as AppGrammarAidIndexImport } from './routes/_app/grammar-aid/index'
import { Route as AppClassesIndexImport } from './routes/_app/classes/index'
import { Route as AppProductsProductIdImport } from './routes/_app/products/$productId'
import { Route as AppGrammarAidTopicSlugImport } from './routes/_app/grammar-aid/$topicSlug'
import { Route as AppClassesClassIdImport } from './routes/_app/classes/$classId'
import { Route as AppClassesClassIdIndexImport } from './routes/_app/classes/$classId/index'
import { Route as AppClassesClassIdBlockBlockIdxImport } from './routes/_app/classes/$classId/block/$blockIdx'

// Create/Update Routes

const WelcomeRoute = WelcomeImport.update({
  id: '/welcome',
  path: '/welcome',
  getParentRoute: () => rootRoute,
} as any)

const JournalRoute = JournalImport.update({
  id: '/journal',
  path: '/journal',
  getParentRoute: () => rootRoute,
} as any)

const AppRoute = AppImport.update({
  id: '/_app',
  getParentRoute: () => rootRoute,
} as any)

const AppIndexRoute = AppIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppRoute,
} as any)

const AppValidateRoute = AppValidateImport.update({
  id: '/validate',
  path: '/validate',
  getParentRoute: () => AppRoute,
} as any)

const AppOnboardRoute = AppOnboardImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => AppRoute,
} as any)

const AppMuralRoute = AppMuralImport.update({
  id: '/mural',
  path: '/mural',
  getParentRoute: () => AppRoute,
} as any)

const AppMellinaiRoute = AppMellinaiImport.update({
  id: '/mellinai',
  path: '/mellinai',
  getParentRoute: () => AppRoute,
} as any)

const AppJourneyRoute = AppJourneyImport.update({
  id: '/journey',
  path: '/journey',
  getParentRoute: () => AppRoute,
} as any)

const AppFeedbackRoute = AppFeedbackImport.update({
  id: '/feedback',
  path: '/feedback',
  getParentRoute: () => AppRoute,
} as any)

const AppConquistasRoute = AppConquistasImport.update({
  id: '/conquistas',
  path: '/conquistas',
  getParentRoute: () => AppRoute,
} as any)

const AppCentralRoute = AppCentralImport.update({
  id: '/central',
  path: '/central',
  getParentRoute: () => AppRoute,
} as any)

const AppCalendarRoute = AppCalendarImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => AppRoute,
} as any)

const AppProductsIndexRoute = AppProductsIndexImport.update({
  id: '/products/',
  path: '/products/',
  getParentRoute: () => AppRoute,
} as any)

const AppGrammarAidIndexRoute = AppGrammarAidIndexImport.update({
  id: '/grammar-aid/',
  path: '/grammar-aid/',
  getParentRoute: () => AppRoute,
} as any)

const AppClassesIndexRoute = AppClassesIndexImport.update({
  id: '/classes/',
  path: '/classes/',
  getParentRoute: () => AppRoute,
} as any)

const AppProductsProductIdRoute = AppProductsProductIdImport.update({
  id: '/products/$productId',
  path: '/products/$productId',
  getParentRoute: () => AppRoute,
} as any)

const AppGrammarAidTopicSlugRoute = AppGrammarAidTopicSlugImport.update({
  id: '/grammar-aid/$topicSlug',
  path: '/grammar-aid/$topicSlug',
  getParentRoute: () => AppRoute,
} as any)

const AppClassesClassIdRoute = AppClassesClassIdImport.update({
  id: '/classes/$classId',
  path: '/classes/$classId',
  getParentRoute: () => AppRoute,
} as any)

const AppClassesClassIdIndexRoute = AppClassesClassIdIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AppClassesClassIdRoute,
} as any)

const AppClassesClassIdBlockBlockIdxRoute =
  AppClassesClassIdBlockBlockIdxImport.update({
    id: '/block/$blockIdx',
    path: '/block/$blockIdx',
    getParentRoute: () => AppClassesClassIdRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof AppImport
      parentRoute: typeof rootRoute
    }
    '/journal': {
      id: '/journal'
      path: '/journal'
      fullPath: '/journal'
      preLoaderRoute: typeof JournalImport
      parentRoute: typeof rootRoute
    }
    '/welcome': {
      id: '/welcome'
      path: '/welcome'
      fullPath: '/welcome'
      preLoaderRoute: typeof WelcomeImport
      parentRoute: typeof rootRoute
    }
    '/_app/calendar': {
      id: '/_app/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof AppCalendarImport
      parentRoute: typeof AppImport
    }
    '/_app/central': {
      id: '/_app/central'
      path: '/central'
      fullPath: '/central'
      preLoaderRoute: typeof AppCentralImport
      parentRoute: typeof AppImport
    }
    '/_app/conquistas': {
      id: '/_app/conquistas'
      path: '/conquistas'
      fullPath: '/conquistas'
      preLoaderRoute: typeof AppConquistasImport
      parentRoute: typeof AppImport
    }
    '/_app/feedback': {
      id: '/_app/feedback'
      path: '/feedback'
      fullPath: '/feedback'
      preLoaderRoute: typeof AppFeedbackImport
      parentRoute: typeof AppImport
    }
    '/_app/journey': {
      id: '/_app/journey'
      path: '/journey'
      fullPath: '/journey'
      preLoaderRoute: typeof AppJourneyImport
      parentRoute: typeof AppImport
    }
    '/_app/mellinai': {
      id: '/_app/mellinai'
      path: '/mellinai'
      fullPath: '/mellinai'
      preLoaderRoute: typeof AppMellinaiImport
      parentRoute: typeof AppImport
    }
    '/_app/mural': {
      id: '/_app/mural'
      path: '/mural'
      fullPath: '/mural'
      preLoaderRoute: typeof AppMuralImport
      parentRoute: typeof AppImport
    }
    '/_app/onboard': {
      id: '/_app/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof AppOnboardImport
      parentRoute: typeof AppImport
    }
    '/_app/validate': {
      id: '/_app/validate'
      path: '/validate'
      fullPath: '/validate'
      preLoaderRoute: typeof AppValidateImport
      parentRoute: typeof AppImport
    }
    '/_app/': {
      id: '/_app/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AppIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/classes/$classId': {
      id: '/_app/classes/$classId'
      path: '/classes/$classId'
      fullPath: '/classes/$classId'
      preLoaderRoute: typeof AppClassesClassIdImport
      parentRoute: typeof AppImport
    }
    '/_app/grammar-aid/$topicSlug': {
      id: '/_app/grammar-aid/$topicSlug'
      path: '/grammar-aid/$topicSlug'
      fullPath: '/grammar-aid/$topicSlug'
      preLoaderRoute: typeof AppGrammarAidTopicSlugImport
      parentRoute: typeof AppImport
    }
    '/_app/products/$productId': {
      id: '/_app/products/$productId'
      path: '/products/$productId'
      fullPath: '/products/$productId'
      preLoaderRoute: typeof AppProductsProductIdImport
      parentRoute: typeof AppImport
    }
    '/_app/classes/': {
      id: '/_app/classes/'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof AppClassesIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/grammar-aid/': {
      id: '/_app/grammar-aid/'
      path: '/grammar-aid'
      fullPath: '/grammar-aid'
      preLoaderRoute: typeof AppGrammarAidIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/products/': {
      id: '/_app/products/'
      path: '/products'
      fullPath: '/products'
      preLoaderRoute: typeof AppProductsIndexImport
      parentRoute: typeof AppImport
    }
    '/_app/classes/$classId/': {
      id: '/_app/classes/$classId/'
      path: '/'
      fullPath: '/classes/$classId/'
      preLoaderRoute: typeof AppClassesClassIdIndexImport
      parentRoute: typeof AppClassesClassIdImport
    }
    '/_app/classes/$classId/block/$blockIdx': {
      id: '/_app/classes/$classId/block/$blockIdx'
      path: '/block/$blockIdx'
      fullPath: '/classes/$classId/block/$blockIdx'
      preLoaderRoute: typeof AppClassesClassIdBlockBlockIdxImport
      parentRoute: typeof AppClassesClassIdImport
    }
  }
}

// Create and export the route tree

interface AppClassesClassIdRouteChildren {
  AppClassesClassIdIndexRoute: typeof AppClassesClassIdIndexRoute
  AppClassesClassIdBlockBlockIdxRoute: typeof AppClassesClassIdBlockBlockIdxRoute
}

const AppClassesClassIdRouteChildren: AppClassesClassIdRouteChildren = {
  AppClassesClassIdIndexRoute: AppClassesClassIdIndexRoute,
  AppClassesClassIdBlockBlockIdxRoute: AppClassesClassIdBlockBlockIdxRoute,
}

const AppClassesClassIdRouteWithChildren =
  AppClassesClassIdRoute._addFileChildren(AppClassesClassIdRouteChildren)

interface AppRouteChildren {
  AppCalendarRoute: typeof AppCalendarRoute
  AppCentralRoute: typeof AppCentralRoute
  AppConquistasRoute: typeof AppConquistasRoute
  AppFeedbackRoute: typeof AppFeedbackRoute
  AppJourneyRoute: typeof AppJourneyRoute
  AppMellinaiRoute: typeof AppMellinaiRoute
  AppMuralRoute: typeof AppMuralRoute
  AppOnboardRoute: typeof AppOnboardRoute
  AppValidateRoute: typeof AppValidateRoute
  AppIndexRoute: typeof AppIndexRoute
  AppClassesClassIdRoute: typeof AppClassesClassIdRouteWithChildren
  AppGrammarAidTopicSlugRoute: typeof AppGrammarAidTopicSlugRoute
  AppProductsProductIdRoute: typeof AppProductsProductIdRoute
  AppClassesIndexRoute: typeof AppClassesIndexRoute
  AppGrammarAidIndexRoute: typeof AppGrammarAidIndexRoute
  AppProductsIndexRoute: typeof AppProductsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppCalendarRoute: AppCalendarRoute,
  AppCentralRoute: AppCentralRoute,
  AppConquistasRoute: AppConquistasRoute,
  AppFeedbackRoute: AppFeedbackRoute,
  AppJourneyRoute: AppJourneyRoute,
  AppMellinaiRoute: AppMellinaiRoute,
  AppMuralRoute: AppMuralRoute,
  AppOnboardRoute: AppOnboardRoute,
  AppValidateRoute: AppValidateRoute,
  AppIndexRoute: AppIndexRoute,
  AppClassesClassIdRoute: AppClassesClassIdRouteWithChildren,
  AppGrammarAidTopicSlugRoute: AppGrammarAidTopicSlugRoute,
  AppProductsProductIdRoute: AppProductsProductIdRoute,
  AppClassesIndexRoute: AppClassesIndexRoute,
  AppGrammarAidIndexRoute: AppGrammarAidIndexRoute,
  AppProductsIndexRoute: AppProductsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof AppRouteWithChildren
  '/journal': typeof JournalRoute
  '/welcome': typeof WelcomeRoute
  '/calendar': typeof AppCalendarRoute
  '/central': typeof AppCentralRoute
  '/conquistas': typeof AppConquistasRoute
  '/feedback': typeof AppFeedbackRoute
  '/journey': typeof AppJourneyRoute
  '/mellinai': typeof AppMellinaiRoute
  '/mural': typeof AppMuralRoute
  '/onboard': typeof AppOnboardRoute
  '/validate': typeof AppValidateRoute
  '/': typeof AppIndexRoute
  '/classes/$classId': typeof AppClassesClassIdRouteWithChildren
  '/grammar-aid/$topicSlug': typeof AppGrammarAidTopicSlugRoute
  '/products/$productId': typeof AppProductsProductIdRoute
  '/classes': typeof AppClassesIndexRoute
  '/grammar-aid': typeof AppGrammarAidIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/classes/$classId/': typeof AppClassesClassIdIndexRoute
  '/classes/$classId/block/$blockIdx': typeof AppClassesClassIdBlockBlockIdxRoute
}

export interface FileRoutesByTo {
  '/journal': typeof JournalRoute
  '/welcome': typeof WelcomeRoute
  '/calendar': typeof AppCalendarRoute
  '/central': typeof AppCentralRoute
  '/conquistas': typeof AppConquistasRoute
  '/feedback': typeof AppFeedbackRoute
  '/journey': typeof AppJourneyRoute
  '/mellinai': typeof AppMellinaiRoute
  '/mural': typeof AppMuralRoute
  '/onboard': typeof AppOnboardRoute
  '/validate': typeof AppValidateRoute
  '/': typeof AppIndexRoute
  '/grammar-aid/$topicSlug': typeof AppGrammarAidTopicSlugRoute
  '/products/$productId': typeof AppProductsProductIdRoute
  '/classes': typeof AppClassesIndexRoute
  '/grammar-aid': typeof AppGrammarAidIndexRoute
  '/products': typeof AppProductsIndexRoute
  '/classes/$classId': typeof AppClassesClassIdIndexRoute
  '/classes/$classId/block/$blockIdx': typeof AppClassesClassIdBlockBlockIdxRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_app': typeof AppRouteWithChildren
  '/journal': typeof JournalRoute
  '/welcome': typeof WelcomeRoute
  '/_app/calendar': typeof AppCalendarRoute
  '/_app/central': typeof AppCentralRoute
  '/_app/conquistas': typeof AppConquistasRoute
  '/_app/feedback': typeof AppFeedbackRoute
  '/_app/journey': typeof AppJourneyRoute
  '/_app/mellinai': typeof AppMellinaiRoute
  '/_app/mural': typeof AppMuralRoute
  '/_app/onboard': typeof AppOnboardRoute
  '/_app/validate': typeof AppValidateRoute
  '/_app/': typeof AppIndexRoute
  '/_app/classes/$classId': typeof AppClassesClassIdRouteWithChildren
  '/_app/grammar-aid/$topicSlug': typeof AppGrammarAidTopicSlugRoute
  '/_app/products/$productId': typeof AppProductsProductIdRoute
  '/_app/classes/': typeof AppClassesIndexRoute
  '/_app/grammar-aid/': typeof AppGrammarAidIndexRoute
  '/_app/products/': typeof AppProductsIndexRoute
  '/_app/classes/$classId/': typeof AppClassesClassIdIndexRoute
  '/_app/classes/$classId/block/$blockIdx': typeof AppClassesClassIdBlockBlockIdxRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/journal'
    | '/welcome'
    | '/calendar'
    | '/central'
    | '/conquistas'
    | '/feedback'
    | '/journey'
    | '/mellinai'
    | '/mural'
    | '/onboard'
    | '/validate'
    | '/'
    | '/classes/$classId'
    | '/grammar-aid/$topicSlug'
    | '/products/$productId'
    | '/classes'
    | '/grammar-aid'
    | '/products'
    | '/classes/$classId/'
    | '/classes/$classId/block/$blockIdx'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/journal'
    | '/welcome'
    | '/calendar'
    | '/central'
    | '/conquistas'
    | '/feedback'
    | '/journey'
    | '/mellinai'
    | '/mural'
    | '/onboard'
    | '/validate'
    | '/'
    | '/grammar-aid/$topicSlug'
    | '/products/$productId'
    | '/classes'
    | '/grammar-aid'
    | '/products'
    | '/classes/$classId'
    | '/classes/$classId/block/$blockIdx'
  id:
    | '__root__'
    | '/_app'
    | '/journal'
    | '/welcome'
    | '/_app/calendar'
    | '/_app/central'
    | '/_app/conquistas'
    | '/_app/feedback'
    | '/_app/journey'
    | '/_app/mellinai'
    | '/_app/mural'
    | '/_app/onboard'
    | '/_app/validate'
    | '/_app/'
    | '/_app/classes/$classId'
    | '/_app/grammar-aid/$topicSlug'
    | '/_app/products/$productId'
    | '/_app/classes/'
    | '/_app/grammar-aid/'
    | '/_app/products/'
    | '/_app/classes/$classId/'
    | '/_app/classes/$classId/block/$blockIdx'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  JournalRoute: typeof JournalRoute
  WelcomeRoute: typeof WelcomeRoute
}

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  JournalRoute: JournalRoute,
  WelcomeRoute: WelcomeRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_app",
        "/journal",
        "/welcome"
      ]
    },
    "/_app": {
      "filePath": "_app.tsx",
      "children": [
        "/_app/calendar",
        "/_app/central",
        "/_app/conquistas",
        "/_app/feedback",
        "/_app/journey",
        "/_app/mellinai",
        "/_app/mural",
        "/_app/onboard",
        "/_app/validate",
        "/_app/",
        "/_app/classes/$classId",
        "/_app/grammar-aid/$topicSlug",
        "/_app/products/$productId",
        "/_app/classes/",
        "/_app/grammar-aid/",
        "/_app/products/"
      ]
    },
    "/journal": {
      "filePath": "journal.tsx"
    },
    "/welcome": {
      "filePath": "welcome.tsx"
    },
    "/_app/calendar": {
      "filePath": "_app/calendar.tsx",
      "parent": "/_app"
    },
    "/_app/central": {
      "filePath": "_app/central.tsx",
      "parent": "/_app"
    },
    "/_app/conquistas": {
      "filePath": "_app/conquistas.tsx",
      "parent": "/_app"
    },
    "/_app/feedback": {
      "filePath": "_app/feedback.tsx",
      "parent": "/_app"
    },
    "/_app/journey": {
      "filePath": "_app/journey.tsx",
      "parent": "/_app"
    },
    "/_app/mellinai": {
      "filePath": "_app/mellinai.tsx",
      "parent": "/_app"
    },
    "/_app/mural": {
      "filePath": "_app/mural.tsx",
      "parent": "/_app"
    },
    "/_app/onboard": {
      "filePath": "_app/onboard.tsx",
      "parent": "/_app"
    },
    "/_app/validate": {
      "filePath": "_app/validate.tsx",
      "parent": "/_app"
    },
    "/_app/": {
      "filePath": "_app/index.tsx",
      "parent": "/_app"
    },
    "/_app/classes/$classId": {
      "filePath": "_app/classes/$classId.tsx",
      "parent": "/_app",
      "children": [
        "/_app/classes/$classId/",
        "/_app/classes/$classId/block/$blockIdx"
      ]
    },
    "/_app/grammar-aid/$topicSlug": {
      "filePath": "_app/grammar-aid/$topicSlug.tsx",
      "parent": "/_app"
    },
    "/_app/products/$productId": {
      "filePath": "_app/products/$productId.tsx",
      "parent": "/_app"
    },
    "/_app/classes/": {
      "filePath": "_app/classes/index.tsx",
      "parent": "/_app"
    },
    "/_app/grammar-aid/": {
      "filePath": "_app/grammar-aid/index.tsx",
      "parent": "/_app"
    },
    "/_app/products/": {
      "filePath": "_app/products/index.tsx",
      "parent": "/_app"
    },
    "/_app/classes/$classId/": {
      "filePath": "_app/classes/$classId/index.tsx",
      "parent": "/_app/classes/$classId"
    },
    "/_app/classes/$classId/block/$blockIdx": {
      "filePath": "_app/classes/$classId/block/$blockIdx.tsx",
      "parent": "/_app/classes/$classId"
    }
  }
}
ROUTE_MANIFEST_END */
